import _regeneratorRuntime from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//

import repo from '@/api/system-setting/user';
import ChangePasswordDialog from "./views/components/ChangePasswordDialog";
export default {
  components: {
    ChangePasswordDialog: ChangePasswordDialog
  },
  data: function data() {
    return {
      hasChecked: false,
      changePasswordDialogVisible: false
    };
  },
  computed: {
    user: function user() {
      return this.$store.getters.user;
    }
  },
  watch: {
    user: {
      immediate: true,
      handler: function handler(val) {
        var _this = this;
        if (!val || !val.username) {
          return;
        }
        setTimeout(function () {
          _this.initUserStatus();
        }, 3000);
      }
    }
  },
  methods: {
    /**
     * 初始化用户状态
     */
    initUserStatus: function () {
      var _initUserStatus = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var needToChangePassword;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.hasChecked) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return repo.checkNeedToUpdatePass();
            case 4:
              needToChangePassword = _context.sent;
              if (needToChangePassword) {
                this.showConfirmMessage();
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initUserStatus() {
        return _initUserStatus.apply(this, arguments);
      }
      return initUserStatus;
    }(),
    showConfirmMessage: function showConfirmMessage() {
      var _this2 = this;
      this.$confirm('检测到该账号密码为弱密码，请前往修改密码，否则将无法继续使用系统。', '警告', {
        confirmButtonText: '修改密码',
        cancelButtonText: '退出登录',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(function () {
        _this2.onShowChangePwdDialog();
      }).catch(function (action) {
        if (action === 'cancel') {
          _this2.$store.dispatch('LogOut').then(function () {
            location.reload();
          });
        }
      });
    },
    /**
     * 修改密码
     */
    onShowChangePwdDialog: function onShowChangePwdDialog() {
      this.changePasswordDialogVisible = true;
    },
    onCloseChangePwdDialog: function onCloseChangePwdDialog() {
      this.changePasswordDialogVisible = false;
      this.showConfirmMessage();
    },
    /**
     * 完成修改
     */
    onFinished: function onFinished() {
      this.changePasswordDialogVisible = false;
      this.hasChecked = true;
      location.reload();
    }
  }
};